<ng-template vdrDialogTitle>{{ "common.refundReq" | translate }}</ng-template>
<div style="white-space: pre-wrap; display: flex; flex-direction: row">
  <div style="flex: 1" *ngIf="refundReq.assets.length > 0">
    <vdr-assets
      [assets]="refundReq.assets"
      [compact]="true"
      [featuredAsset]="refundReq.assets[0]"
      [updatePermissions]="['__disabled__']"
    ></vdr-assets>
  </div>
  <div style="flex: 2; display: flex; flex-direction: column">
    <div class="form-grid">
      <vdr-form-field [label]="'common.orderNumber' | translate">
        <a
          class="button-ghost"
          [routerLink]="['/orders', refundReq.orderId]"
          target="_blank"
        >
          <span>{{ orderNumber | async }}</span>
          <clr-icon shape="arrow right" />
        </a>
      </vdr-form-field>

      <vdr-form-field [label]="'common.user' | translate">
        <custom-customer-label
          [customer]="customer$ | async"
        ></custom-customer-label>
      </vdr-form-field>
    </div>
    <vdr-form-field class="mt-2" [label]="'common.refundReason' | translate">
      {{ refundReq.reason }}
    </vdr-form-field>

    <vdr-form-field
      style="margin-top: 1rem"
      [label]="'common.details' | translate"
    >
      <div style="overflow-x: auto; width: 100%">
        <order-detail-table
          [refundLines]="refundReq.args.refunds[0].lines"
          [lines]="refundReq.lines"
          [currencyCode]="currencyCode"
          (closeEvent)="close()"
        ></order-detail-table>
      </div>
    </vdr-form-field>
  </div>
</div>
<ng-template vdrDialogButtons>
  <ng-container *ngFor="let button of buttons">
    <button
      class="button ml-1"
      *ngIf="this.refundReq.status !== 'approved'; else approved"
      [class.primary]="button.type === 'primary'"
      [class.danger]="button.type === 'danger'"
      [disabled]="button.disabled ?? false"
      (click)="resolveWith(button.returnValue)"
    >
      {{ button.label | translate }}
    </button>
    <ng-template #approved>
      <button class="button ml-1" [class.primary]="button.type === 'primary'"
        [class.danger]="button.type === 'danger'"
        [disabled]="button.disabled ?? false"
        (click)="handleApprovedButtonClick(button)"
      >
        {{ button.label | translate }}
      </button>
    </ng-template>
  </ng-container>
</ng-template>
